import React, { Component } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { AppBar, IconButton, Typography, Drawer, Button, Snackbar, Slide } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Brightness5Icon from '@material-ui/icons/Brightness5';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import HelpIcon from '@material-ui/icons/Help';

import { lightTheme, darkTheme } from './config/theme';
import Game from './containers/game';
import Home from './containers/home';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      play: false,
      theme: darkTheme,
      drawer: false,
      snackbar: {
        open: false,
        message: ""
      }
    };
    this.name = '';
    this.roomCode = null;
    this.host = false;
    this.play = this.play.bind(this);
    this.setName = this.setName.bind(this);
    this.setRoomCode = this.setRoomCode.bind(this);
    this.setHost = this.setHost.bind(this);
    this.stopGame = this.stopGame.bind(this);
  };

  play() {
    this.setState({ play: true });
  };

  setName(name) {
    this.name = name;
  };

  setRoomCode(code) {
    this.roomCode = code;
  };

  setHost(bool) {
    this.host = bool;
  }

  toggleTheme() {
    this.setState({theme: this.state.theme === lightTheme ? darkTheme : lightTheme});
  };

  toggleHelp(toggle) {
    this.setState({drawer: toggle});
  };

  stopGame() {
    this.setState({play: false});
  };

  handleSnackbarOpen = (message) => {
    this.setState(() => ({ 
      snackbar: { 
        ...this.state.snackbar, 
        open: true, 
        message
      }
    }));
    this.stopGame();
  };

  handleSnackbarClose= () => {
    this.setState(() => ({ 
      snackbar: { 
        ...this.state.snackbar, 
        open: false, 
        message: ""
      }
    }));
  };

  render() {
    return (
      <MuiThemeProvider theme={this.state.theme}>
        <AppBar
          style={{maxHeight: 50, display: "inline-block"}}
          color="secondary"
        >
          { this.state.play &&
            <IconButton
              onClick={() => this.stopGame()}
              size="small"
              style={{width: 50}}
            >
             <ArrowBackIcon/>
            </IconButton>
          }
          <IconButton
            onClick={() => this.toggleTheme()}
            size="small"
            style={{width: 50, float: "right"}}
          >
            {this.state.theme === lightTheme ? <Brightness4Icon/> : <Brightness5Icon/>} 
          </IconButton>
          <IconButton
            onClick={() => this.toggleHelp(!this.state.drawer)}
            size="small"
            style={{width: 50, float: "right"}}
          >
            <HelpIcon/>
          </IconButton>
        </AppBar>
        <Drawer style={{ textAlign: "center", backgroundColor: this.state.theme.palette.background.default}} anchor="right" open={this.state.drawer} onClose={() => this.toggleHelp(false)}>
          <Button
            onClick={() => this.toggleHelp(false)}
            size="small"
            variant="contained"
            fullWidth
          >
            <ArrowBackIcon/> Close
          </Button>
          <Typography variant="h4" style={{marginTop: 10, marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 25}}>
            To Start a New Game: 
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 15}}>
            1. Click Host Game on device to host from.
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 15}}>
            2. All players click Join Game from their devices.
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 25}}>
            3. All players must enter Room Code displayed on hosting device's Screen.
          </Typography>
          <Typography variant="h4" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 25}}>
            How to Play: 
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 15}}>
            The first round each player will be prompted to enter in an action, object, or maybe even something silly. (i.e. Ice Cream, Surfing, Hunting, Hitler reluctantly shaving his moustache...)
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 15}}>
            The second round each player's prompt will be passed to another player. It is then each player's duty to draw the prompt they got as well as they possibly can.
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 15}}>
            The Third round each player will receive an image that was drawn by a previous player, *Note: the Initial prompt will not be attached. The player will then try and guess the image they received.
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 15}}>
            From here on, each prompt/drawing will be passed around among the player's. The players will then have to either draw or guess for each turn for what they receive. They will not however see more than what was submitted the previous turn.
          </Typography>
          <Typography variant="body1" style={{marginRight: 10, marginLeft: 10, maxWidth: 350, marginBottom: 25}}>
            After all player's have either created a prompt or drawing for each of eachother's artwork. (Max 8 turns) The game will end, sit back, relax, and lets watch a breakdown of where each prompt lead.
          </Typography>
          <Button
            onClick={() => this.toggleHelp(false)}
            size="small"
            variant="contained"
            fullWidth
          >
            <ArrowBackIcon/> Close
          </Button>
        </Drawer>
        <div style={{ backgroundColor: this.state.theme.palette.background.default, height: "100vh", overflowX: "hidden" }}>
          { this.state.play ?
            <Game name={this.name} setName={this.setName} roomCode={this.roomCode} host={this.host} theme={this.state.theme} stopGame={this.stopGame} openSnackbar={this.handleSnackbarOpen} /> :
            <Home play={this.play} name={this.name} setName={this.setName} theme={this.state.theme} setRoomCode={this.setRoomCode} setHost={this.setHost} openSnackbar={this.handleSnackbarOpen} />
          }
        </div>
        <Snackbar
          open={this.state.snackbar.open}
          onClose={this.handleSnackbarClose}
          message={this.state.snackbar.message}
          TransitionComponent={Transition}
          autoHideDuration={6000}
        />
      </MuiThemeProvider>
    );
  }
};